import { render, staticRenderFns } from "./classVideo.vue?vue&type=template&id=58c12efe&"
import script from "./classVideo.vue?vue&type=script&lang=js&"
export * from "./classVideo.vue?vue&type=script&lang=js&"
import style0 from "./classVideo.vue?vue&type=style&index=0&id=58c12efe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports